

<div class="filter-container" [ngSwitch]="!!categoryList">

  <div *ngSwitchCase="true">
    <div class="desktop">
      <p *ngFor="let category of categoryList " style="padding:0.3rem 0;">
        <mat-checkbox
          [color]="'primary'"
          [checked]="category.id === checkedID"
          (change)="check(category, $event.checked)">
          {{category.name}}
        </mat-checkbox>
      </p>
    </div>

    <div class="mobile">
      <div
        class="btn btn-pollstar btn-pollstar-fullwidth btn-blue filter-toggle"
        (click)="toggleFilter()"
      >Filtra i premi</div>
      <div
        #rewardCategoryFilterPanel
        class="reward-category-filter-panel"
        [ngClass]="isMobileVisible ? 'panelVisible' : 'panelHidden'"
      >
        <p *ngFor="let category of categoryList" style="padding:0.3rem 0;">
          <mat-checkbox
            [color]="'primary'"
            [checked]="category.id === checkedID"
            (change)="check(category, $event.checked)">
            {{category.name}}
          </mat-checkbox>
        </p>
      </div>
    </div>

  </div>

  <div *ngSwitchDefault>
    <app-card-overlay [background]="false"></app-card-overlay>
  </div>

</div>
